<header class="admin-topbar">

  <button type="button" class="menu-toggle" (click)="menuToggle.emit()" aria-label="Toggle sidebar">
    <span class="pi pi-bars"></span>
  </button>

  <div class="topbar-actions">
    <div class="topbar-clock">
      <span class="pi pi-clock"></span>
      <span>{{ currentTime }}</span>
    </div>

    <div class="topbar-divider"></div>

    <a class="user-chip" routerLink="/settings" title="Settings">
      <div class="user-chip-avatar">{{ userProfileStore.initials() || 'A' }}</div>
      <div class="user-chip-text">
        <p class="user-chip-name">{{ userProfileStore.fullName() || 'Admin User' }}</p>
        <p class="user-chip-role">{{ userProfileStore.roleName() || 'Admin' }}</p>
      </div>
    </a>

    <button type="button" class="icon-btn logout-btn" title="Sign out" (click)="onLogout()">
      <span class="pi pi-sign-out"></span>
    </button>
  </div>
</header>
